import { useEffect } from 'react'

import { chatApi } from '@/api/chat'

/** Как часто подтверждаем присутствие; сервер держит отметку дольше интервала. */
const HEARTBEAT_INTERVAL_MS = 30_000

/**
 * Присутствие в комнате: пока лента открыта, сервер не шлёт пуш и письмо по
 * сообщениям, которые пользователь и так видит на экране.
 *
 * Нужен везде, где лента активна, — и на странице чата, и в панели урока:
 * без него участники идущего урока получали бы уведомление о каждой реплике
 * собеседника, сидя на этой же странице.
 */
export function useChatPresence(roomId: number | null): void {
  useEffect(() => {
    if (roomId === null) return

    const heartbeat = () => {
      void chatApi.enterPresence(roomId).catch(() => {})
    }

    heartbeat()
    const intervalId = window.setInterval(heartbeat, HEARTBEAT_INTERVAL_MS)

    return () => {
      window.clearInterval(intervalId)
      void chatApi.leavePresence(roomId).catch(() => {})
    }
  }, [roomId])
}
